import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

/**
 * Native Status Bar Controller
 */
export const NativeStatusBar = {
  /**
   * Set status bar theme (DARK for light text, LIGHT for dark text, DEFAULT)
   * @param {'DARK'|'LIGHT'|'DEFAULT'} style
   */
  setStyle: async (style = 'DARK') => {
    if (Capacitor.isNativePlatform()) {
      try {
        const targetStyle = style === 'LIGHT' ? Style.Light : Style.Dark;
        await StatusBar.setStyle({ style: targetStyle });
      } catch (e) {
        console.warn('Failed to set status bar style', e);
      }
    }
  },

  /**
   * Set background color for Android status bar
   * @param {string} color Hex color string (e.g. '#0f172a')
   */
  setBackgroundColor: async (color = '#0f172a') => {
    if (Capacitor.isNativePlatform()) {
      try {
        await StatusBar.setBackgroundColor({ color });
      } catch (e) {
        console.warn('Failed to set status bar background color', e);
      }
    }
  },

  /**
   * Hide status bar
   */
  hide: async () => {
    if (Capacitor.isNativePlatform()) {
      await StatusBar.hide();
    }
  },

  /**
   * Show status bar
   */
  show: async () => {
    if (Capacitor.isNativePlatform()) {
      await StatusBar.show();
    }
  },

  /**
   * Set whether the status bar overlays the webview (for edge-to-edge screens)
   */
  setOverlaysWebView: async (overlay = false) => {
    if (Capacitor.isNativePlatform()) {
      await StatusBar.setOverlaysWebView({ overlay });
    }
  }
};

export default NativeStatusBar;
